import config from "@config";
const datePickerOptions = {
  placeholder: "dd/mm/yyyy",
  dateFormat: config.dateFormatBE,
};

export default function(t: (name: string) => string) {
  return {
    id: {
      "ui:title": "Position ID",
      "ui:disabled": true,
    },
    fte: {
      "ui:title": "FTE",
      "ui:widget": "number-input",
    },
    weeklyContractedHoursInSeconds: {
      "ui:widget": "seconds-as-hours-input",
    },
    organisationalUnit: {
      "ui:widget": "radio-hierarchy-tree-modal",
    },
    shiftPattern: {
      "ui:widget": "select",
    },
    activeFrom: {
      "ui:widget": "date-picker",
      "ui:options": datePickerOptions,
      "ui:title": t("POSITION_START_DATE"),
    },
    activeTo: {
      "ui:widget": "date-picker",
      "ui:options": datePickerOptions,
      "ui:title": t("POSITION_END_DATE"),
    },
    isActive: {
      "ui:widget": "hidden",
    },

    "ui:order": [
      "id",
      "status",
      "activeFrom",
      "activeTo",
      "employeePositionReference",
      "jobTitle",
      "staffGroup",
      "organisationalUnit",
      "fte",
      "weeklyContractedHoursInSeconds",
      "daysPerYear",
      "shiftPattern",
      "salary",
      "isActive",
    ],
  };
}
